import { ExperienceWorkModel } from "../models/ExperienceWorkModel"
import ExperienceWork from "./List/ExperienceWork"
import ListTemplate from "./List/ListTemplate"

function Experience() {
    return (
        <div>
            <big className="section-header">Experience</big>
            <ListTemplate component={ExperienceWork} data={ExperienceWorkModel} sectionTitle="Work Experience"/>
        </div>
    )
}

export default Experience